@if (page !== null) {
  <sk-toolbar class="bordered-top py-1 px-2" [size]="'sm'">
    <ng-template contentLeft>
      @if (!!totalItemsCount) {
        <span data-test="total-items">
        {{ 'label.TotalItems' | translate }}:
          @if (showNumberOfCurrentItems) {
            <span>{{ currentItems }} {{ 'label.of' | translate }}</span>
          }
          {{ totalItemsCount }}
      </span>
      }

      @if (selectedRowsCount) {
        <span data-test="selected-rows-count">
        ({{ 'label.Selected' | translate }}: {{ selectedRowsCount }})
      </span>
      }
    </ng-template>

    <ng-template contentRight>
      @if (!!totalItemsCount) {
        <sk-button data-test="first-page"
                   [appearance]="'icon'"
                   [disabled]="isFirstPage"
                   (click)="setPage(firstPage)">
          <i class="fal fa-angle-double-left"></i>
        </sk-button>
      }

      <sk-button data-test="previous-page"
              [appearance]="'icon'"
              [disabled]="isFirstPage"
              (click)="setPage(page - 1)">
        <i class="fal fa-angle-left"></i>
      </sk-button>

      <div data-test="page-number" class="page-number ps-1 pe-1">
        <span>{{ 'label.Page' | translate }}</span>

        @if (showPageSelector && totalItemsCount) {
          <sk-number
            data-test="page-number"
            class="ps-1"
            [style.width.px]="pageSelectorWidth || 60"
            [stylingMode]="toolbarFiltersStylingMode()"
            [noSubscriptBox]="true"
            [extraDense]="true"
            [(ngModel)]="page"
            (ngModelChange)="setPage(page)"
            [min]="1">
          </sk-number>
        }

        @if (!showPageSelector || (showPageSelector && !totalItemsCount)) {
          <span class="ps-1">{{ page }}</span>
        }

        @if (!!totalItemsCount) {
          <span class="ps-1">{{ 'label.of' | translate }} <span class="ps-1">{{ pagesCount }}</span></span>
        }
      </div>

      <sk-button data-test="next-page"
              [appearance]="'icon'"
              [disabled]="isLastPage"
              (click)="setPage(page + 1)">
        <i class="fal fa-angle-right"></i>
      </sk-button>

      @if (!!totalItemsCount) {
        <sk-button data-test="last-page"
                   [appearance]="'icon'"
                   [disabled]="isLastPage"
                   (click)="setPage(pagesCount)">
          <i class="fal fa-angle-double-right"></i>
        </sk-button>
      }

      @if (showPageSizeSelector) {
        <span>
          {{ 'label.PageSize' | translate }}
        </span>

        <sk-select data-test="page-size"
                   class="dropdown-width-native"
                   appendTo="body"
                   bindValue="size"
                   bindLabel="size"
                   [stylingMode]="toolbarFiltersStylingMode()"
                   [noSubscriptBox]="true"
                   [extraDense]="true"
                   [items]="pageSizes"
                   [searchable]="false"
                   [clearable]="false"
                   [(ngModel)]="pageSize"
                   (ngModelChange)="onPageSizeChanged()">
        </sk-select>
      }
    </ng-template>
  </sk-toolbar>
}
